import { mergeSearchColumns } from '@utils/columns';
import _ from 'lodash';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useColumns as useAllColumns } from '@modules/decision/decision-columns';
import { useDecisions } from '@modules/decision/decisions';
import { Search } from '@composite/search/search';
import { ExportTags } from '@enums';
import { useColumns } from './decsion-search-columns';

const DECISION_SEARCH_VERSION = 17;
const DECISION_SEARCH_IDENTIFIER = 'DECISION_SEARCH';

export function DecisionSearch() {
  const searchColumns = useColumns();
  const allColumns = useAllColumns(false);
  const intl = useIntl();

  const { props } = useDecisions({
    evidenceProps: {
      version: DECISION_SEARCH_VERSION,
      identifier: DECISION_SEARCH_IDENTIFIER,
      tableProps: {
        tableName: intl.formatMessage({
          id: 'ES__DECISIONS_SEARCH__TABLE__TITLE',
          defaultMessage: 'Rozhodnutí - hledání',
        }),
      },
    },
  });
  return (
    <Search
      version={props.version}
      apiProps={props.apiProps}
      detailProps={props.detailProps}
      tableProps={{
        ...props.tableProps,
        reportTag: ExportTags.DECISIONS,
        showSearchbar: true,
        columns: _.uniqBy(
          mergeSearchColumns(allColumns, searchColumns),
          'datakey'
        ),
        settingsKey: DECISION_SEARCH_IDENTIFIER,
      }}
      filterProps={{
        title: (
          <FormattedMessage
            id="ES__DECISION_SEARCH__TOOLBAR__TITLE"
            defaultMessage="Vyhledávání"
          />
        ),
        initVisibility: searchColumns.map((c) => c.datakey),
        defaults: [],
        groupLabels: {
          1: intl.formatMessage({
            id: 'ES__DECISION_SEARCH__LABEL_GROUP_0',
            defaultMessage: 'Obecné',
          }),
          2: intl.formatMessage({
            id: 'ES__DECISION_SEARCH__LABEL_GROUP_1',
            defaultMessage: 'Text',
          }),
          3: intl.formatMessage({
            id: 'ES__DECISION_SEARCH__LABEL_GROUP_2',
            defaultMessage: 'Spis',
          }),
        },
      }}
    />
  );
}
